import {Component, Input} from '@angular/core';
import {EventStatus} from '../shared/webhook-event.model';
import {Moment} from 'moment';

@Component({
  selector: 'app-webhook-event-status',
  templateUrl: './webhook-event-status.component.html',
  styleUrls: ['./webhook-event-status.component.scss']
})
export class WebhookEventStatusComponent {

  @Input()
  public status: EventStatus;

  @Input()
  public nextTryDate: Moment;

  public EventStatus = EventStatus;

}
